// extracted by mini-css-extract-plugin
module.exports = {"tileWrapper":"_21d50b50","visuallySimilarWrapper":"_f0ada844","favoritesWrapper":"_1bf06ee3","folderIconWrapper":"_e53af7b9","heartIconWrapper":"_20f643e5"};